import React from "react";
import "../../assets/css/timeline.css"

const Timeline = (props) => {
  const {timelineData} = props;

  const toPascalCase = (word) => {
    return word?.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  return <div className="p-1 ms-4">
    <ul className="timeline">
      {timelineData.map((data, index) => {
        return <li key={index} className="timeline-item mb-4">
          <div className="row">
            <div className="col-md-2">
              {Object.entries(data.object_changes).map(([key, value], index) => {
                return key === 'status' && (
                  <div key={index} className="col-md-2">
                    <h6 className="fw-bold">
                      {toPascalCase(value[1])}
                    </h6>
                  </div>
                )})
              }
              <p className="text-muted mb-2 fw-bold">{data.done_at?.split(' ').join(' | ')}</p>
            </div>
            <div className="col-md-2">
              <p className="text-muted mb-2 fw-bold">Done by</p>
              {data.whodunnit ? <p className="text-muted mb-2">{data.whodunnit?.id} | {data.whodunnit?.name}</p> : '- -'}
            </div>
            <div className="col-md-2">
              <p className="text-muted mb-2 fw-bold">Role</p>
              {data.role ? <p className="text-muted mb-2">{toPascalCase(data.role)}</p> : '- -'}
            </div>
            {Object.entries(data.object_changes).map(([key, value], index) => (
              key === 'status' && <div key={index} className="col-md-2">
                <p className="text-muted mb-2 fw-bold">
                  {toPascalCase(key)}:
                </p>
                <p className="text-muted mb-2">
                  {value.toString()?.split(',').join(' ➟ ')}
                </p>
              </div>
            ))}
          </div>
        </li>
      })}
    </ul>
  </div>
}

export default Timeline;